module.exports = __webpack_public_path__ + "media/images/basic_logos/plus-24c42e280b1dba454089e4a714b141f6.svg";